<div class="choose-us-container container">
  <img src="assets/logo-icon-shadow.svg" alt="logo"/>
  <p class="section-pre-header" i18n>Why choose us?</p>
  <h1 i18n>Why Choose Akl Bayti</h1>
  <p i18n>Why settle for ordinary when you can experience the extraordinary? Akl Bayti connects you with local chefs passionate about bringing gourmet, home-cooked meals directly to your table. Discover unique dishes made with love and the freshest ingredients, support local talent, and transform your dining experience.</p>
</div>
